import { useQuery } from '@tanstack/react-query';
import { getAuditForms } from 'api/audits';
import { auditFormsKeys } from 'api/queryKeys';
import { useMainCompanyQuery } from './useMainCompanyQuery';
import { IAuditFormsRequest } from 'types/audits';

export const useAuditFormsQuery = (filters?: IAuditFormsRequest['filters']) => {
  const { data: mainCompany } = useMainCompanyQuery();
  const companyId = mainCompany?.id ?? '';

  return useQuery({
    queryKey: auditFormsKeys.list(companyId, filters),
    queryFn: () => getAuditForms({ filters: filters ?? {} }).then((res) => res.data ?? []),
    enabled: !!companyId
  });
};
